import React, { useMemo, useState } from 'react';
import Popover from '@material-ui/core/Popover';

export type PopupAlign = 'left' | 'right';

type Props = {
  anchorEl: HTMLElement | null;
  // コメント欄の起点。right ならコメント欄は左へ伸びる
  align?: PopupAlign;
  promptText: string;
  disabled?: boolean;
  onSubmit: (comment: string) => void;
  onClose: () => void;
};

const FeedbackCommentPopup = ({
  anchorEl,
  align = 'left',
  promptText,
  disabled = false,
  onSubmit,
  onClose
}: Props) => {
  const [comment, setComment] = useState('');
  const trimmedComment = comment.trim();
  const isSubmitDisabled = trimmedComment.length === 0 || disabled;
  const styles = useMemo(() => getStyles(), []);

  const handleSubmit = () => {
    if (isSubmitDisabled) return;
    onSubmit(trimmedComment);
  };

  return (
    <Popover
      open
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: align }}
      transformOrigin={{ vertical: 'top', horizontal: align }}
      PaperProps={{ style: styles.paper }}
    >
      <div style={styles.content} role="dialog" aria-label="feedback-comment-popup">
        <div style={styles.promptText}>{promptText}</div>
        <textarea
          style={styles.textarea}
          value={comment}
          onChange={event => setComment(event.target.value)}
          placeholder="ご自由にお書きください"
          rows={3}
          disabled={disabled}
        />
        <button
          type="button"
          style={isSubmitDisabled ? styles.submitButtonDisabled : styles.submitButton}
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
        >
          送信する
        </button>
      </div>
    </Popover>
  );
};

const getStyles = () =>
  ({
    paper: {
      width: '460px',
      boxSizing: 'border-box',
      marginTop: '4px',
      padding: '12px',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)'
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    promptText: {
      fontSize: '12px',
      color: '#333',
      lineHeight: 1.5
    },
    textarea: {
      width: '100%',
      padding: '8px',
      fontSize: '13px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      resize: 'vertical',
      fontFamily: 'inherit',
      boxSizing: 'border-box'
    },
    submitButton: {
      padding: '6px 12px',
      fontSize: '13px',
      color: '#fff',
      background: '#1976d2',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      alignSelf: 'flex-end'
    },
    submitButtonDisabled: {
      padding: '6px 12px',
      fontSize: '13px',
      color: '#fff',
      background: '#bdbdbd',
      border: 'none',
      borderRadius: '4px',
      cursor: 'not-allowed',
      alignSelf: 'flex-end'
    }
  } as const);

export default FeedbackCommentPopup;
